import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';
import classnames from 'classnames';

import SvgIcon from 'common/components/SvgIcon';

import './Button.less';

class Button extends Component {

    onClick = (e) => {
        e.target.closest('.Button').blur();

        if (this.props.onClick) {
            e.preventDefault();

            this.props.onClick(e);
        }
    };

    render() {

        const { className, type, icon, color, border, size, grow, isProcessing, to, disabled, float, transparent, submit, children, ...props } = this.props;

        const classes = classnames(
            className,
            `Button--type-${type}`,
            `Button--color-${color}`,
            `Button--border-${border}`,
            `Button--size-${size}`,
            {
                [`Button--float-${float}`]: float,
                'Button--grow': grow,
                'Button--isProcessing': isProcessing,
                'Button--transparent': transparent
            },
            'Button'
        );

        if (this.props.to) {
            return (
                <Link {...props}
                      className={classes}
                      to={to}
                      onClick={this.onClick}>
                    <span className="Button-content">
                        {type === 'icon' && icon &&
                            <SvgIcon namespace='control' icon={icon} />
                        }
                        {children}
                    </span>
                    <span className="Button-loader"/>
                </Link>
            );
        } else {
            return (
                <button disabled={disabled}
                        className={classes}
                        onClick={this.onClick}>
                    <span className="Button-content">
                        {type === 'icon' && icon &&
                            <SvgIcon namespace='control' icon={icon} />
                        }
                        {children}
                    </span>
                    <span className="Button-loader"/>
                </button>
            );
        }
    }
}

Button.defaultProps = {
    className: '',
    type: 'bordered',
    border: 'thin',
    color: 'black',
    size: 'normal',
    grow: false,
    transparent: false,
    to: null,
    isProcessing: false,
    disabled: false
};

Button.propTypes = {
    className: PropTypes.string,
    grow: PropTypes.bool,
    transparent: PropTypes.bool,
    type: PropTypes.oneOf(['text', 'simple', 'bordered', 'solid', 'icon']),
    border: PropTypes.oneOf(['bold','thin']),
    color: PropTypes.oneOf(['white', 'black', 'primary', 'danger', 'green', 'blue', 'pink']),
    size: PropTypes.oneOf(['small', 'normal', 'large']),
    float: PropTypes.oneOf(['left', 'right']),
    onClick: PropTypes.func,
    disabled: PropTypes.bool
};

export default Button;



// WEBPACK FOOTER //
// ./assets/app/common/components/Button/Button.jsx